import React from "react"

export default function QuienesSomos() {
  return (
    <main className="max-w-6xl mx-auto px-6 py-16 space-y-12">
      {/* Encabezado principal */}
      <section className="text-center">
        <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
          Quiénes Somos
        </h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          QuipusMania es una plataforma de comparación de precios y ubicación de
          comercios que conecta compradores con vendedores locales de manera
          confiable y eficiente.
        </p>
      </section>

      {/* Misión */}
      <section className="bg-white rounded-xl shadow-lg border border-gray-200 p-10 transition-transform hover:scale-[1.02]">
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">🎯Misión</h2>
        <p className="text-gray-700 leading-relaxed">
          Conectar de manera eficiente a consumidores y empresas en Venezuela,
          facilitando el acceso a una amplia gama de productos y servicios,
          optimizando la búsqueda por ubicación y precio, y fomentando el
          crecimiento del comercio local.
        </p>
      </section>

      {/* Visión */}
      <section className="bg-white rounded-xl shadow-lg border border-gray-200 p-10 transition-transform hover:scale-[1.02]">
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">🧭Visión</h2>
        <p className="text-gray-700 leading-relaxed">
          Ser la plataforma líder en Venezuela para la búsqueda y comparación de
          productos y servicios, reconocida por su innovación, confiabilidad y
          por impulsar la economía digital, transformando la experiencia de
          compra y venta para todos.
        </p>
      </section>

      {/* Objetivos */}
      <section className="bg-white rounded-xl shadow-lg border border-gray-200 p-10 transition-transform hover:scale-[1.02]">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          💡Objetivos
        </h2>
        <ul className="space-y-2 text-gray-700 list-disc pl-6">
          <li>
            Facilitar la visibilidad de productos y servicios de empresas de
            todos los tamaños.
          </li>
          <li>
            Ofrecer herramientas de búsqueda avanzadas para una experiencia de
            usuario óptima.
          </li>
          <li>
            Proporcionar análisis de mercado y estadísticas a empresas
            afiliadas.
          </li>
          <li>
            Garantizar la transparencia en precios y ubicación para los
            consumidores.
          </li>
          <li>Impulsar la digitalización del comercio venezolano.</li>
        </ul>
      </section>
    </main>
  )
}
